export const HOME_HEALTH_CASES_PATH = "/home-health/cases";
export const HOME_HEALTH_CASE_MOBILE_DETAIL_PATH = "/home-health/cases/:caseId";
const I18N_SKIP_HOME_HEALTH_CREATE_CASE_PATH = "/home-health/cases/new";
export const HOME_HEALTH_CREATE_CASE_PATH = I18N_SKIP_HOME_HEALTH_CREATE_CASE_PATH;
const I18N_SKIP_HOME_HEALTH_ADD_VISIT_PATH = "/home-health/cases/:caseId/visits/new";
export const HOME_HEALTH_ADD_VISIT_PATH = I18N_SKIP_HOME_HEALTH_ADD_VISIT_PATH;

export function getHomeHealthCaseMobileDetailPath(caseId: string): string {
  return `/home-health/cases/${caseId}`;
}

export function getHomeHealthAddVisitPath(caseId: string): string {
  return `/home-health/cases/${caseId}/visits/new`;
}
